import { SupportedDiagnosticCases, definitions, DiagnosticSets  } from "@piceasoft/core";
import { strings } from "../../localization/strings";
import { getEnumValidNumberKeys, range } from "../helpers/common";

export const setsDescriber = (id?: number) : string => {

    if (id == undefined) return ""

    return definitions.diagnostic.setDescriber(id, "name") ?? id?.toString() ?? ""
}

export const testDescriber = (id?: number) => {

    if (id == undefined) return ""

    return definitions.diagnostic.caseDescriber(id, "name") ?? id?.toString() ?? ""
}

export function verifyDescriber(check: number): string {
    return definitions.verify.checkDescriber(check) ?? strings.PICEA.VERIFY.CHECKS.UNKNOWN_CHECK as string;
}

export const verifyStatusDescriber = (id: number): string => {
    return definitions.verify.statusDescriber(id, "name") ?? id.toString();
}

export const getPiceaSetCasesIndexRange = (set: DiagnosticSets):number[] => {
    return getEnumValidNumberKeys(SupportedDiagnosticCases, range(16, set))
}

export const getPiceaSetIdByCaseId = (caseId: number): number | undefined => {
    const setsTo = getEnumValidNumberKeys(DiagnosticSets, range(caseId + 1, 0))

    if (setsTo.length > 0) {
        return Math.max(...setsTo)
    }
}
